module.exports = __webpack_public_path__ + "src/assets/models/spectrophotometer/red_coloring.fbx";